/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Agent_Readiness_Classification_HintInputs */

const en_directory_agent_readiness_classification_hint = /** @type {(inputs: Directory_Agent_Readiness_Classification_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Where this product sits on the spectrum from human-operated to agent-native.`)
};

const zh_directory_agent_readiness_classification_hint = /** @type {(inputs: Directory_Agent_Readiness_Classification_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`该产品在「人工操作 → Agent 原生」光谱上的位置。`)
};

/**
* | output |
* | --- |
* | "Where this product sits on the spectrum from human-operated to agent-native." |
*
* @param {Directory_Agent_Readiness_Classification_HintInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_agent_readiness_classification_hint = /** @type {((inputs?: Directory_Agent_Readiness_Classification_HintInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Agent_Readiness_Classification_HintInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_agent_readiness_classification_hint(inputs)
	return zh_directory_agent_readiness_classification_hint(inputs)
});
export { directory_agent_readiness_classification_hint as "directory.agent_readiness.classification_hint" }